import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper
  },
  image: {
    height: '40px',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  box: {
    display: 'flex',
    width: '300px',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  text: {
    textAlign: 'center',
  },
}));

export default useStyles;
